// 组件对象，大写
import checkboxRemote from './checkboxRemote.vue'
export default checkboxRemote
